var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"public-login"},[_c('div',{staticClass:"login-box"},[_c('div',{staticClass:"box-btn",on:{"click":function($event){return _vm.goPage('/login')}}},[_vm._m(0)])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-info"},[_c('i',{staticClass:"btn-icon login"}),_c('span',{staticClass:"btn-text"},[_vm._v("Log in")])])
}]

export { render, staticRenderFns }